import { DOMParser as XmldomParser } from "@xmldom/xmldom";
import type { SvgImportIssueCollector } from "./issues";

export function parseSvgDocument(markup: string, issues: SvgImportIssueCollector): Document {
  const Parser = typeof globalThis.DOMParser !== "undefined" ? globalThis.DOMParser : XmldomParser;
  const doc = new Parser().parseFromString(markup, "image/svg+xml");
  const root = doc.documentElement;
  if (!root || root.nodeName === "parsererror" || root.getElementsByTagName("parsererror").length > 0) {
    issues.add({ code: "parse-error", message: "Failed to parse SVG markup" });
    throw new Error("Failed to parse SVG markup");
  }
  return doc as unknown as Document;
}

export function svgRootElement(doc: Document): SVGSVGElement | Element {
  const root = doc.documentElement;
  if (root.localName?.toLowerCase() === "svg" || root.nodeName.toLowerCase() === "svg") {
    return root;
  }
  const svg = doc.getElementsByTagName("svg")[0];
  if (!svg) {
    throw new Error("SVG root element not found");
  }
  return svg;
}

export function elementLocalName(element: Element): string {
  return (element.localName ?? element.nodeName).replace(/^.*:/, "").toLowerCase();
}

export function childElements(element: Element): Element[] {
  return Array.from(element.childNodes).filter((node): node is Element => node.nodeType === 1);
}

export function readSvgLength(value: string | null | undefined, fallback = 0): number {
  if (!value) {
    return fallback;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed === "none") {
    return fallback;
  }
  const match = trimmed.match(/^(-?[\d.]+)(px)?$/);
  if (match) {
    return Number(match[1]);
  }
  return Number.parseFloat(trimmed) || fallback;
}

export function readSvgNumberList(value: string | null | undefined): number[] {
  if (!value) {
    return [];
  }
  return value
    .trim()
    .split(/[\s,]+/)
    .map(token => Number.parseFloat(token))
    .filter(number => Number.isFinite(number));
}
